export class CacheConstants {
  public static readonly ARTIFACTS_PREFIX = 'Artifacts';
}